import 'shop/SlerpStyles'

import { useTheme } from 'shop/theme'

import ShopClient from 'shop/client'

import { Router } from './router'
import { DevInfoBanner } from 'shop/components/DevInfoBanner'
import GlobalContext from 'shop/hooks/useGlobalContext/GlobalContext'
import config from 'shop/config'
import { initSentry } from 'reporting/sentry'
import { useEffect } from 'react'
import useHotjar from 'shop/hooks/useHotjar'

const SlerpSpace = () => {
  const [theme] = useTheme((config.theme && config.theme) || {})
  const { initHotjar, removeHotjar } = useHotjar()

  const isDevEnv: boolean = !!process.env.REACT_APP_TEST_ENV

  const environment = process.env.REACT_APP_TEST_ENV || process.env.NODE_ENV

  initSentry({
    environment: environment
  })

  // Inject Hotjar tracking script into the <head> of the document on load.
  useEffect(() => {
    initHotjar({ environment: environment })

    return () => {
      // Cleanup Hotjar on unmount
      removeHotjar()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  /** Temp: Switch pathname for domain masked partners if they haven't updated yet */
  useEffect(() => {
    if (window.location.hostname === 'www.crosstown.co.uk') {
      const newHostName = 'order.crosstown.co.uk'
      window.location.href = `https://${newHostName}${window.location.pathname}${window.location.search}`
    }
    if (window.location.hostname === 'eataly.co.uk') {
      const newHostName = 'eataly.slerp.com'
      window.location.href = `https://${newHostName}${window.location.pathname}${window.location.search}`
    }
  }, [])

  return (
    <ShopClient config={config}>
      <GlobalContext theme={theme}>
        {isDevEnv && <DevInfoBanner />}
        <Router />
      </GlobalContext>
    </ShopClient>
  )
}

export default SlerpSpace
